import { Map } from 'immutable';

import * as t from '../../actions/dashboardActionType';

const initialState = Map({
  loadingFeaturedBlog: true,
  featuredBlog: {
    description: '',
    imageUrl: '',
    link: '#',
  },
});

const reducer = function DashboardFeaturedBlogReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.SET_FEATURED_BLOG:
      return state.set('featuredBlog', action.featuredBlog);

    case t.SET_IS_LOADING_FEATURED_BLOG:
      return state.set('loadingFeaturedBlog', action.isLoadingFeaturedBlog);

    default:
      return state;
  }
};

export default reducer;
